/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconGuillotine: {
  name: 'guillotine';
  data: string;
} = {
  name: 'guillotine',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M190.503 36.712v112.583l245.338-61.036V36.711l-245.338.001zm245.338 73.287-245.338 61.036v53.864l245.338-61.745v-53.155zM455.153 36.799h33.208v536.042h-33.208V36.799zM136.552 36.799h33.208v536.042h-33.208V36.799zM190.503 444.313v54.051h80.945c4.567-21.012 22.152-36.681 43.143-36.681s38.538 15.671 43.106 36.681h78.144v-52.855l-245.338-1.196zm0 75.155v52.444h245.338v-52.444h-77.994c-4.384 21.279-22.088 37.204-43.255 37.204s-38.87-15.927-43.255-37.204h-80.834z"/></svg>`,
};
